import t from "../SmIcon/SmIcon.vue.js";
import { defineComponent as a, createElementBlock as l, openBlock as n, normalizeClass as p, createBlock as r, createCommentVNode as c, createElementVNode as i, toDisplayString as m } from "vue";
const g = /* @__PURE__ */ a({
  __name: "STag",
  props: {
    type: { default: "primary" },
    leadingIcon: {},
    label: {}
  },
  setup(s) {
    return (e, _) => {
      const o = t;
      return n(), l("div", {
        class: p(["sm-tag-next", e.type])
      }, [
        e.leadingIcon ? (n(), r(o, {
          key: 0,
          icon: e.leadingIcon,
          height: "12px",
          width: "12px"
        }, null, 8, ["icon"])) : c("", !0),
        i("span", null, m(e.label), 1)
      ], 2);
    };
  }
});
export {
  g as default
};
